export const extractFiltersFromURL = (): { fieldValue: string; optionValues: string[] }[] => {
  const params = new URLSearchParams(new URL(location.href).search)
  const url = new URL(location.href)
  
  /*
    If there is an existing page param in the URL we will remove it here as entering a new filter,
    while on a paginated page, should cause the page and results to reset.
  */ 
  if (params.has('page')) {
    params.delete('page')
    history.replaceState(null, '', url.pathname + '?' + params.toString())
  }
  
  const filterMap: Map<string, string[]> = new Map()
  params.forEach((value, key) => {
    if (key.startsWith('filter.')) {
      const field = key.replace('filter.', '')
      
      if (!filterMap.has(field)) {
        filterMap.set(field, []);
      }
      filterMap.get(field)!.push(value)
    }

    if (key.startsWith('sort.')) {
      const sortField = key.replace('sort.', '')
      
      if (!filterMap.has('sort')) {
        filterMap.set('sort', [])
      }
      filterMap.get('sort')!.push(`${sortField}=${value}`)
    }
  })

  const filterArray = Array.from(filterMap.entries()).map(([fieldValue, optionValues]) => ({
    fieldValue,
    optionValues
  }))

  return filterArray
}

export const extractFilterParamsFromURL = (): { filterArray: { fieldValue: string; optionValues: string[] }[], page?: number } => {
  const params = new URLSearchParams(new URL(location.href).search)
  let page: number | undefined
  const urlContainsFilterOrPageParam = location.href.includes('filter.') || location.href.includes('page') || location.href.includes('sort')

  if (urlContainsFilterOrPageParam) {
    const filterMap: Map<string, string[]> = new Map()

    params.forEach((value, key) => {
      if (key.startsWith('filter.')) {
        const field = key.replace('filter.', '')

        if (!filterMap.has(field)) {
          filterMap.set(field, [])
        }
        filterMap.get(field)!.push(value)
      }

      if (key === 'page') {
        page = parseInt(value, 10)
      }

      if (key.startsWith('sort.')) {
        const sortField = key.replace('sort.', '')

        if (!filterMap.has('sort')) {
          filterMap.set('sort', [])
        }
        filterMap.get('sort')!.push(`${sortField}=${value}`)
      }
    })

    const filterArray = Array.from(filterMap.entries()).map(([fieldValue, optionValues]) => ({
      fieldValue,
      optionValues
    }))

    return { filterArray, page }
  }

  return { filterArray: [], page }
}